export const GET_CANCELLATION_POLICY_CONSTANTS_REQUEST = 'GET_CANCELLATION_POLICY_CONSTANTS_REQUEST';
export const GET_CANCELLATION_POLICY_CONSTANTS_RESPONSE = 'GET_CANCELLATION_POLICY_CONSTANTS_RESPONSE';

export const GET_MIMAR_CONSTANTS_REQUEST = 'GET_MIMAR_CONSTANTS_REQUEST' ;
export const GET_MIMAR_CONSTANTS_RESPONSE = 'GET_MIMAR_CONSTANTS_RESPONSE';

export const UPDATE_APP_CONSTANTS = 'UPDATE_APP_CONSTANTS';

